import React from 'react';
import ReactPlayer from 'react-player';

function VideoControl({ showControls, volume, url, className }) {
  return (
    <div className={`w-full p-4 ${className}`}>
      <ReactPlayer controls={showControls ?? true} volume={volume ?? 0.25} url={url} width="100%" />
    </div>
  );
}

export default VideoControl;
